let activeAccountId: string | null = null;

export function setOfflineAccountScope(accountId: string | null): void {
  activeAccountId = accountId?.trim() || null;
}

export function offlineAccountScope(): string | null {
  return activeAccountId;
}

export function requireOfflineAccountScope(): string {
  const accountId = offlineAccountScope();
  if (!accountId) throw new Error('Local draft account scope is unavailable');
  return accountId;
}
